// Carousel: The Arrows
// Supports multiple carousels on the same page. Each `.carousel` is paired with
// the `.carousel-controls` inside its nearest `.container`, and scrolls one
// card/slide at a time.
document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll(".carousel")

  carousels.forEach((carousel) => {
    const container = carousel.closest(".container") || carousel.parentElement
    const controls = container ? container.querySelector(".carousel-controls") : null
    const leftArrow = controls ? controls.querySelector(".left-arrow") : null
    const rightArrow = controls ? controls.querySelector(".right-arrow") : null
    const item = carousel.querySelector(":scope > li, :scope > div")

    if (!controls || !leftArrow || !rightArrow || !item) return

    // Amount to scroll: one card/slide width, including the gap to the next one
    const getScrollAmount = () => {
      const gap = parseFloat(getComputedStyle(carousel).columnGap || getComputedStyle(carousel).gap) || 0
      return item.offsetWidth + gap
    }

    // Hide the controls entirely when there isn't enough content to scroll
    const updateControlsVisibility = () => {
      const hasScroll = carousel.scrollWidth > carousel.offsetWidth + 1
      controls.style.display = hasScroll ? "flex" : "none"
    }

    // Check scroll position and update arrow classes
    const updateArrowClasses = () => {
      const scrollLeft = carousel.scrollLeft
      const maxScrollLeft = carousel.scrollWidth - carousel.offsetWidth

      // Check if at the start
      if (scrollLeft <= 0) {
        leftArrow.classList.add("disabled")
      } else {
        leftArrow.classList.remove("disabled")
      }

      // Check if at the end
      if (scrollLeft >= maxScrollLeft - 1) {
        rightArrow.classList.add("disabled")
      } else {
        rightArrow.classList.remove("disabled")
      }
    }

    // Scroll left
    leftArrow.addEventListener("click", () => {
      carousel.scrollBy({
        left: -getScrollAmount(),
        behavior: "smooth",
      })
      setTimeout(updateArrowClasses, 300) // Update classes after scrolling
    })

    // Scroll right
    rightArrow.addEventListener("click", () => {
      carousel.scrollBy({
        left: getScrollAmount(),
        behavior: "smooth",
      })
      setTimeout(updateArrowClasses, 300) // Update classes after scrolling
    })

    // Initial check for controls/arrow states
    updateControlsVisibility()
    updateArrowClasses()

    // Keep everything in sync on scroll and on viewport changes
    carousel.addEventListener("scroll", updateArrowClasses)
    window.addEventListener("resize", () => {
      updateControlsVisibility()
      updateArrowClasses()
    })
  })

  // ###################
  // Accessibility - Move with keyboard
  // const cards = document.querySelectorAll('.carousel .grid__item');
  // cards.forEach((card, idx) => {
  //   card.addEventListener('keydown', function (event) {
  //     if (event.key === 'ArrowRight') {
  //       event.preventDefault();
  //       if (idx < cards.length - 1) {
  //         cards[idx + 1].focus();
  //         cards[idx + 1].scrollIntoView({ behavior: 'smooth', inline: 'center' });
  //       }
  //     } else if (event.key === 'ArrowLeft') {
  //       event.preventDefault();
  //       if (idx > 0) {
  //         cards[idx - 1].focus();
  //         cards[idx - 1].scrollIntoView({ behavior: 'smooth', inline: 'center' });
  //       }
  //     }
  //   });
  // });
})
